// isRepeatSignup — did supabase.auth.signUp just hit an existing, confirmed
// account?
//
// Why this exists (Sep 25 2026): Supabase answers a sign-up for an email that
// already has a CONFIRMED account with success and sends NO email — that's its
// guard against revealing which addresses are registered. The only tell is
// that the returned user has an empty `identities` array. None of our sign-up
// forms checked it, so they all showed "Check your inbox" for an email that was
// never coming. A real user hit that three times in one evening and gave up.
//
// An UNCONFIRMED existing account is different: Supabase re-sends the
// confirmation email and returns a non-empty `identities`, so "check your
// inbox" is correct there and this returns false.
import type { User } from "@supabase/supabase-js";

export function isRepeatSignup(user: User | null | undefined): boolean {
  return !!user && Array.isArray(user.identities) && user.identities.length === 0;
}

/** Shared copy so all three sign-up forms say the same thing. */
export const REPEAT_SIGNUP_TITLE = "You already have an account";
export const REPEAT_SIGNUP_DESCRIPTION =
  "Sign in with your password, or tap “Forgot your password?” for a reset link.";
